import React from "react";
import { Icon } from "../icons/Icon";
import type { IconName } from "../icons/icons";
import { cn } from "@/lib/styles.utils";

interface PillProps extends React.ComponentProps<"button"> {
  label: React.ReactNode;
  icon?: IconName;
  iconClassName?: string;
  as?: "button" | "span" | "div";
  className?: string;
}

export function Pill({
  label,
  icon,
  className,
  iconClassName,
  as = "div",
  disabled,
  ...rest
}: PillProps) {
  const Comp: any = as;
  const isButton = as === "button";

  return (
    <Comp
      type={isButton ? "button" : undefined}
      className={cn(
        "inline-flex items-center gap-2 rounded-full transition-colors select-none px-4 py-1.5 text-sm",
        isButton && !disabled && "cursor-pointer",
        disabled && "opacity-60 cursor-not-allowed",
        className,
      )}
      disabled={isButton ? disabled : undefined}
      {...rest}
    >
      {icon && (
        <Icon
          name={icon}
          className={cn("shrink-0 size-3", iconClassName || "")}
        />
      )}
      <div className="leading-none text-nowrap">{label}</div>
    </Comp>
  );
}
